import { css } from "@emotion/core";
import { Link, graphql } from "gatsby";
import React from "react";

import { Content } from "../components/Content";
import Flex from "../components/Flex";
import Layout from "../components/Layout";
import { Menu } from "../components/Menu";
import Section from "../components/Section";
import SEO from "../components/seo";

const LegalTwoColumn = ({
  data: {
    markdownRemark: {
      html,
      frontmatter: { title, subtitle },
    },
  },
}) => (
  <Layout>
    <SEO title={title} />

    <Section>
      <Content>
        <div
          css={css`
            margin-bottom: 7.5rem;
          `}
        >
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
        <Flex
          css={css`
            justify-content: space-between;

            @media only screen and (max-width: 520px) {
              flex-wrap: wrap;

              & > div {
                width: 100%;
              }
            }
          `}
        >
          <div
            dangerouslySetInnerHTML={{ __html: html }}
            css={css`
              width: 63%;
              order: 1;
              margin-bottom: 6rem;

              @media only screen and (max-width: 520px) {
                order: 0;
              }
            `}
          />
          <div>
            <Menu>
              <h4>Terms</h4>
              <p>
                <Link to="/legal/terms">Terms of service</Link>
              </p>
              <p>
                <Link to="/legal/e-sign-disclosure">E-Sign disclosure</Link>
              </p>
              <h4>Privacy</h4>
              <p>
                <Link to="/privacy">Privacy policy</Link>
              </p>
              <p>
                <Link to="/transparency">Transparency report</Link>
              </p>
              <h4>Products & programs</h4>
              <p>
                <Link to="/legal/rewards">Flexa Rewards</Link>
              </p>
              <h4>Security</h4>
              <p>
                <Link to="/security">Security practices</Link>
              </p>
              <p>
                <Link to="/security/bug-bounty-program">
                  Bug bounty program
                </Link>
              </p>
              <h4>Licenses</h4>
              <p>
                <Link to="/legal/licenses-el-salvador">El Salvador</Link>
              </p>
              <p>
                <Link to="/legal/licenses">United States</Link>
              </p>
            </Menu>
          </div>
        </Flex>
      </Content>
    </Section>
  </Layout>
);

export default LegalTwoColumn;

export const query = graphql`
  query ($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        subtitle
      }
    }
  }
`;
